import { ChartViewKey } from '../../assets/constants'
import { Exchange } from '../../proto/generated/common'
import { Indicator } from '../../proto/generated/indicator'
import { ChartSeries } from '../../components/chartV2/chart.typings'

export interface SeriesGroup {
    id: string
    name: string
    code: string
    addedTime: number
    description?: string
    previousDataPointsRequired: number
    fillFromToIndexes?: number[]
    serieses: ChartSeries[]
    primary: boolean
    category: SeriesGroupCategory
    exchange: Exchange
    removePaneGrp: Function
}

export interface IndicatorParams {
    Length: number
    Source: string
    Offset: number
}

export enum SeriesGroupCategory {
    SERIES_SECURITY,
    SERIES_INDICATOR,
    SERIES_COMPARABLE_SECURITY,
    SERIES_VOLUME,
    SERIES_DRAWING,
    SERIES_DRAWING_TOOL
}

export interface indicatorToAddInfo {
    indicator: Indicator
    viewKey: ChartViewKey
}

export enum CallPutOptions {
    CALL = 'CALL',
    PUT = 'PUT',
    BOTH = 'BOTH'
}

// export type ATMsStrikeMenuItemType = { label: string; value: Strike[] | undefined }
export type ATMsStrikeMenuItemType = { label: string; value: number }
